export default __webpack_public_path__ + "static/media/f_list.96ac21b0.svg";